import gql from "graphql-tag";

export const GET_TEAM_MEMBER = gql`
    query TeamMember($teamId: ID!, $teamMemberUserId: ID!){
        teamMember(teamId: $teamId, teamMemberUserId: $teamMemberUserId) {
            teamId
            teamMemberUserId
            createdAt
            updatedAt
            user {
                userId
                displayName
                email
            }
        }
    }
`;

export const GET_TEAM_MEMBERS = gql`
    query TeamMembers($teamId: ID!, $searchStr: String, $limit: Int, $offset: Int, $orderList: [String]){
        teamMembers(teamId: $teamId, searchStr: $searchStr, limit: $limit, offset: $offset, orderList: $orderList) {
            teamId
            teamMemberUserId
            createdAt
            updatedAt
            user {
                userId
                displayName
                email
            }
        }
    }
`;

export const CREATE_TEAM_MEMBER = gql`
    mutation CreateTeamMember($newTeamMember: newTeamMember!) {
        createTeamMember(
            newTeamMember: $newTeamMember
        ) {
            returnCode
            message
            id
            name
        }
    }
`;

export const DELETE_TEAM_MEMBER = gql`
    mutation DeleteTeam($teamId: ID!, $teamMemberUserId: ID!) {
        deleteTeam(
            deleteTeamId: $teamId
        ) {
            returnCode
            message
        }
    }
`;
